import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { isProduction, isTesting } from '@honeybook/utils-web';
import { registerFormatters, DEFAULT_LOCALE } from '@honeybook/i18n';

i18n.use(initReactI18next).init({
    lng: DEFAULT_LOCALE,
    fallbackLng: { default: [DEFAULT_LOCALE] },
    ns: [],
    resources: { [DEFAULT_LOCALE]: {} },
    debug: !isProduction() && !isTesting(),
    interpolation: { escapeValue: false }
});

registerFormatters();
